var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flexbox-container" }, [
    _c("div", { staticClass: "md-layout md-alignment-top-center" }, [
      _c("div", { staticClass: "md-layout-item md-size-95" }, [
        _c("p", { staticClass: "finish-message" }, [
          _vm._v("無事入力が完了しました")
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-lg btn-primary btn-block",
            on: { click: _vm.back }
          },
          [_vm._v("冷蔵庫ID入力に戻る")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30a1b143", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a1b143","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/Finish.vue
// module id = null
// module chunks = 